module.exports = "/images/cirus-og.png";